
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logcat",
      function () {
        return require("private-next-pages/logcat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logcat"])
      });
    }
  